import React, {useCallback} from 'react'
import {Whisper, Tooltip} from 'rsuite'
import {SelectAll} from '../../../../../app/@components'
import {KTSVG} from '../../../../helpers'
import {Search} from '../../../content/forms/Search'
import {Post} from '../../../../../setup'
import {useMailing} from '../../../../../app/@types'
import {useLocation} from 'react-router'
import {ExtendedCampaignInterface} from '../../../../../app/pages/mailing/campaigns/types'
import {useHistory} from 'react-router-dom'
import {PATH_MAILING} from '../../../../../app/routing/paths'

const DUPLICATE_CAMPAIGN = process.env.REACT_APP_MAILING_DUPLICATE_CAMPAIGN || 'v2/campaigns-double'
const ARCHIVER_CAMPAIGN = process.env.REACT_APP_MAILING_ARCHIVER_CAMPAIGN || 'v2/campaigns-archiver'
const NEW_CAMPAIGN = process.env.REACT_APP_MAILING_NEW_CAMPAIGN || 'v2/campaigns'

interface ActionButtonsProps {
  selectAll: boolean;
  setSelectAll: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedItems: React.Dispatch<React.SetStateAction<number[]>>;
  selectedItems: number[];
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  paginateData: any[];
}

const ActionButtonsHeader: React.FC<ActionButtonsProps> = ({
                                                             selectAll,
                                                             setSelectAll,
                                                             setSelectedItems,
                                                             selectedItems,
                                                             setSearchQuery,
                                                             paginateData,
                                                           }) => {

  const {triggerReload} = useMailing()
  const {pathname} = useLocation()
  const history = useHistory()

  const searchStrings = ['archivees']

  const notArchived = searchStrings.some(searchString => pathname.includes(searchString))

  const handleAction = useCallback(
    async (endpoint: string) => {

      const ids = {campaigns_id: selectedItems}
      await Post<any>(endpoint, ids)
      triggerReload()
      setSelectedItems([])
      setSelectAll(false)
    },
    [selectedItems, setSelectAll, setSelectedItems, triggerReload],
  )

  const NewCampaign = useCallback(
    async () => {

      const {data} = await Post<{data: ExtendedCampaignInterface}>(NEW_CAMPAIGN, {})
      history.push(`${PATH_MAILING.campaign.create}/${data.id}`)
    },
    [history],
  )

  return (
    <div className="row d-flex justify-content-between align-items-center mb-5">

      <div className="col-12 col-lg-9 mt-5 mt-lg-0 order-1 order-lg-0">
        <div className="row">
          <div className="col-12 col-sm-6 col-md-7 mb-5 mb-sm-0 d-flex align-items-center">

            <SelectAll
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              setSelectedItems={setSelectedItems}
              data={paginateData}
            />

            <Whisper placement="top" controlId="control-id-click" trigger="hover"
                     speaker={<Tooltip>Dupliquer</Tooltip>}>
              <button
                className="btn btn-sm btn-icon btn-active-light-warning mx-3"
                onClick={() => handleAction(DUPLICATE_CAMPAIGN)}
                disabled={!selectedItems.length}
              >
                <KTSVG path="/media/icons/duotune/general/gen054.svg" className="svg-icon-2 svg-icon-warning" />
              </button>
            </Whisper>

            {
              !notArchived &&
              <Whisper placement="top" controlId="control-id-click" trigger="hover"
                       speaker={<Tooltip>Archiver</Tooltip>}>
                <button
                  className="btn btn-sm btn-icon btn-active-light-info"
                  onClick={() => handleAction(ARCHIVER_CAMPAIGN)}
                  disabled={!selectedItems.length}
                >
                  <KTSVG path="/media/icons/duotune/files/fil017.svg" className="svg-icon-2 svg-icon-info" />
                </button>
              </Whisper>
            }

          </div>
          <div className="col-12 col-sm-6 col-md-5">
            <Search setSearchInput={setSearchQuery} />
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-3 d-flex justify-content-end order-0 order-lg-1">
        <button className="btn btn-light-primary btn-sm"
                onClick={NewCampaign}
        >
          <KTSVG path="/media/icons/duotune/general/gen035.svg" className="svg-icon-2 me-2" />
          Nouvelle campagne
        </button>
      </div>
    </div>
  )
}

export {ActionButtonsHeader}
